// extracted by mini-css-extract-plugin
module.exports = {"reportError":"ErrorReport_reportError__DhcNh","item":"ErrorReport_item__axpSB"};